import { ProductError } from '../../models';

export enum VideoNodalControlStrategy {
  ALWAYS = 'always', // when possible (except on first video)
  ONLY_ON_END = 'only-on-end', // only if no possibility are given
  NEVER = 'never',
}

export enum VideoNodalType {
  VIDEO = 'video',
  IMAGE = 'image',
}

export enum VideoNodalControlsPositionType {
  LEFT = 'left',
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  CENTER = 'center',
}

export class VideoNodalPossibility {
  sequenceSlug: string;
  label: string;

  constructor(raw?: VideoNodalPossibility) {
    this.sequenceSlug = raw?.sequenceSlug;
    this.label = raw?.label;
  }
}

export class VideoNodalSequence {
  slug: string;
  contentUrl: string;
  type: VideoNodalType;
  success?: boolean;
  hideBack?: boolean;
  backLabel?: string;
  possibilities?: VideoNodalPossibility[];

  constructor(raw?: VideoNodalSequence) {
    this.slug = raw?.slug;
    this.contentUrl = raw?.contentUrl;
    this.type = raw?.type;
    this.success = raw?.success;
    this.hideBack = raw?.hideBack;
    this.backLabel = raw?.backLabel;
    this.possibilities = raw?.possibilities || [];
  }
}

export class VideoNodalData {
  firstSequenceSlug: string;
  backStrategy: VideoNodalControlStrategy;
  restartStrategy: VideoNodalControlStrategy;
  leaveStrategy: VideoNodalControlStrategy;
  controlsPosition: VideoNodalControlsPositionType;
  controlsBackground: boolean;
  sequences: VideoNodalSequence[];

  constructor(raw?: VideoNodalData) {
    this.firstSequenceSlug = raw?.firstSequenceSlug;
    this.backStrategy = raw?.backStrategy;
    this.restartStrategy = raw?.restartStrategy;
    this.leaveStrategy = raw?.leaveStrategy;
    this.controlsPosition = raw?.controlsPosition;
    this.controlsBackground = raw?.controlsBackground;
    this.sequences = raw?.sequences;
  }

  static validate(): ProductError[] {
    return [];
  }
}
